<template>
  <div class="banner-list fl">
    <Carousel
      class="banner-list-wrap"
      :interval="3000"
      arrow="always"
      trigger="click"
      height="400px"
    >
      <carousel-item
        v-for="(item, index) in bannerList"
        :key="index"
      >
        <a
          v-if="item.isShow === 1"
          class="banner-img"
          :href="
            unionFlag
              ? item.bfdUrl
                ? item.bfdUrl
                : 'javascript:void(0)'
              : item.adUrl
                ? item.adUrl
                : 'javascript:void(0)'
          "
          target="_self"
          @click.prevent="clickCarousel(item)"
        >
          <img
            :src="item.adImg"
            alt=""
          />
        </a>
      </carousel-item>
    </Carousel>
  </div>
</template>

<script>
import { CarouselItem, Carousel } from 'element-ui';
import { unionFlag,gioClickHandle  } from '@utils';
export default {
  name: 'BannerList',

  components: {
    Carousel,
    CarouselItem,
  },

  props: {
    bannerList: {
      type: Array,
      default: () => [],
    },
  },

  data(){
    return {
      unionFlag: unionFlag(),
    };
  },
  methods:{
    // 点击轮播图
    clickCarousel(item){
      const params = {
        df_channle:'生日汇',
        df_pagename:'频道首页',
        df_modulename:'轮播',
        df_elementname:''+item.id,
      }
      gioClickHandle('DF_elementClick',params,'channelGio')
      window.location.href = this.unionFlag ? item.bfdUrl ? item.bfdUrl : 'javascript:void(0)' : item.adUrl ? item.adUrl : 'javascript:void(0)'
    }
  }
};
</script>

<style lang="less" scoped>
.banner-list {
  width: 900px;
  .banner-img {
    display: block;
    font-size: 0;
    img {
      width: 100%;
      height: 400px;
    }
  }
  /deep/ .banner-list-wrap {
    &:hover {
      .el-carousel__arrow {
        background: rgba(0, 0, 0, 0.8);
      }
    }
    .el-carousel__container {
      font-size: 0;
    }
    .el-carousel__indicators {
      background: rgba(0, 0, 0, 0.5);
      border-radius: 8px;
      padding: 4px;
      bottom: 10px;
      .el-carousel__indicator {
        margin: 0 4px;
        padding: 0;
        &.is-active {
          .el-carousel__button {
            background: #fe6500;
          }
        }
      }
      .el-carousel__button {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: #fff;
        opacity: 1;
      }
    }
    .el-carousel__arrow {
      width: 35px;
      height: 70px;
      background: #000;
      background: rgba(0, 0, 0, 0.4);
      border-radius: 4px;
      &.el-carousel__arrow--left {
        left: 10px;
      }
      &.el-carousel__arrow--right {
        right: 10px;
      }
      i {
        width: 100%;
        height: 100%;
        &::before {
          content: none;
        }
        &.el-icon-arrow-left {
          background: url("../../assets/images/birthday/banner_pre.png") 0 0
            no-repeat;
          background-size: 100% 100%;
        }
        &.el-icon-arrow-right {
          background: url("../../assets/images/birthday/banner_next.png") 0 0
            no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
}
</style>
